var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLinkedinMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedIn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.69 0 0 2.69 0 6v12c0 3.31 2.69 6 6 6h12c3.31 0 6-2.69 6-6V6c0-3.31-2.69-6-6-6ZM7.52 19.75H4.26V9.25h3.26v10.5ZM5.89 7.82C4.85 7.82 4 6.97 4 5.93s.85-1.89 1.89-1.89 1.89.85 1.89 1.89-.85 1.89-1.89 1.89Zm13.85 11.93h-3.26v-5.11c0-1.22-.02-2.78-1.7-2.78s-1.96 1.33-1.96 2.7v5.19H9.56V9.25h3.13v1.43h.04a3.447 3.447 0 0 1 3.09-1.7c3.3 0 3.91 2.17 3.91 5v5.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedinMono);
export default __webpack_public_path__ + "static/media/social-linkedin-mono.48e80f11bb4cc5fc9e14f966d7794d4e.svg";
export { ForwardRef as ReactComponent };